module.exports = __webpack_public_path__ + "img/Security&Defence.cc84af5f.png";